/**
 * @file Onboarding access request view.
 */
import React from 'react';

import ContentWrap from '../../../components/global/ContentWrap';
import OnboardingAccessRequestFormContainer from '../../../containers/onboarding/access-control/OnboardingAccessRequestFormContainer';

const OnboardingAccessRequestView = () => (
  <div className="wrapper-main content-wrap-gray">
    <div className="flex-auto">
      <ContentWrap size="md">
        <OnboardingAccessRequestFormContainer />
      </ContentWrap>
    </div>
  </div>
);

export default OnboardingAccessRequestView;
